import { registerFunctionalComponent } from 'js/lib/components/component'
import { LOCATION_CHANGE_EVENT } from 'js/lib/history'

const LOAD_MORE_FORM_SELECTOR = '.js-adoption-stories-gallery-load-more-form'
const GALLERY_ITEMS_CONTENT_ID = 'adoption-stories-gallery-items_content'

registerFunctionalComponent('.js-c-pages-adoption-stories-gallery', 'AdoptionStoriesGallery', (component) => {
  component.useHandler(() => {
    let targetStoryId = null

    const tryLoadMore = () => {
      if (!targetStoryId) return
      if (component.element.querySelector(`[data-story-id="${targetStoryId}"]`)) {
        targetStoryId = null
        return
      }

      const form = document.querySelector(LOAD_MORE_FORM_SELECTOR)
      if (!form) return

      // Only submit if there is a next page to load. When the last page has been
      // loaded the load-more frame is replaced with empty content (no hidden page
      // input), so we must not submit — doing so would reload page 1, make the
      // button reappear, and duplicate already-loaded items.
      if (!form.querySelector('input[name="page"]')) return

      form.requestSubmit()
    }

    const observer = new MutationObserver(tryLoadMore)

    const handleLocationChange = () => {
      const params = new URLSearchParams(window.location.search)
      targetStoryId = params.get('story_id')

      if (!targetStoryId) {
        observer.disconnect()
        return
      }

      const galleryContent = document.getElementById(GALLERY_ITEMS_CONTENT_ID)
      if (galleryContent) observer.observe(galleryContent, { childList: true })

      tryLoadMore()
    }

    document.addEventListener(LOCATION_CHANGE_EVENT, handleLocationChange)
    return () => {
      document.removeEventListener(LOCATION_CHANGE_EVENT, handleLocationChange)
      observer.disconnect()
    }
  })
})
